import clsx from 'clsx';
import { FC, HTMLAttributes, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

const THead: FC<PropsWithChildren<HTMLAttributes<HTMLTableSectionElement>>> = ({ className, children }) => (
  <thead className={twMerge(clsx('sticky top-0 print:relative z-10', className))}>{children}</thead>
);

export default THead;
